import Component from './AsyncMonitor.vue';

export default {
  install(Vue) {
    Vue.component('BkfAsyncMonitor', Component);
  },
};
